/**
 * Ryan O'Dowd
 * 2018-02-05
 * © Copyright 2018 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors, isDarkMode}) => {
  return {
    headerComponentWrapper: {
      marginTop: 10,
      marginBottom: 8, // @TODO: onscroll, web overlaps the brain, mobile does not
    },
    graphic: {
      position: 'absolute',
      marginBottom: 16,
      resizeMode: 'contain',
    },
    elephantGraphic: {
      width: 48,
      height: 48,
      top: -4, // @TODO: not working with scale // @TODO: need scale though?
      left: -34, // @TODO: not working with scale // @TODO: need scale though?
    },
    brainGraphic: {
      width: 54,
      height: 86,
      top: -24, // @TODO: why is this so different from the elephant graphic? // @TODO: not working with scale // @TODO: need scale though?
      right: -34, // @TODO: not working with scale // @TODO: need scale though?
    },
    headerText: {
      fontFamily: fonts.secondaryBold,
      textAlign: 'center', // android defaults to left aligned
      paddingTop: 8,
      fontSize: 36,
      lineHeight: 36,
      color: colors.white,
    },
    innerContainer: {
      flexGrow: 1,
      paddingLeft: 0,
    },

    expandIcon: {
      justifySelf: 'center',
      alignSelf: 'center',
      padding: globalScale * 2,
      fontSize: globalScale * 14,
    },

    goalIcon: {
      paddingLeft: globalScale * 8,
    },
    activeGoalIcon: {
      color: colors.accentLight,
      opacity: 1.0,
    },
    completedGoalIcon: {
      opacity: 0.5,
    },
    completedGoalText: {
      opacity: 0.5,
    },
    activeGoalText: {
      color: colors.accentLight,
      fontFamily: fonts.primaryBold,
      opacity: 1.0,
    },
    sectionTitle: { // @TODO: in the dialog...could probably be in commonStyles
      marginTop: globalScale * 16,
      fontSize: globalScale * 16,
      fontFamily: fonts.secondaryBold,
      color: isDarkMode ? colors.white : colors.black,
    },
  };
};

export default getStyles;
